// frontend/src/blog/posts.js
//
// Blog posts registry. Each post is a plain object exporting metadata +
// a JSX render function. Deliberately kept in-code (not a CMS, not
// markdown) so we don't pull a new dependency for 1-3 posts. If post
// volume ever crosses ~20 we'll swap in a proper markdown pipeline.

import PocketAlternatives2026 from './posts/pocket-alternatives-2026.jsx';
import SessionBuddyAlternatives2026 from './posts/session-buddy-alternatives-2026.jsx';
import SaveTabsOpenAnotherComputer from './posts/save-tabs-open-another-computer.jsx';
import SessionManagerMicrosoftEdge from './posts/session-manager-microsoft-edge.jsx';
import BestTabManagers2026 from './posts/best-tab-managers-2026.jsx';
import OneTabAlternatives2026 from './posts/onetab-alternatives-2026.jsx';
import AdhdTabManagement from './posts/adhd-tab-management.jsx';
import TabOverloadScience from './posts/tab-overload-science.jsx';
import OrganizeTabsWithAi from './posts/organize-tabs-with-ai.jsx';
import BrowserExtensionsForResearchers from './posts/browser-extensions-for-researchers.jsx';
import ChromeExtensionsForStudents from './posts/chrome-extensions-for-students.jsx';
import ImportPocketExportBlackmount from './posts/import-pocket-export-blackmount.jsx';
import BlackmountVsOnetab from './posts/blackmount-vs-onetab.jsx';
import BlackmountVsSessionBuddy from './posts/blackmount-vs-session-buddy.jsx';
import BlackmountVsWorkona from './posts/blackmount-vs-workona.jsx';

export const posts = [
  PocketAlternatives2026,
  SessionBuddyAlternatives2026,
  SaveTabsOpenAnotherComputer,
  SessionManagerMicrosoftEdge,
  BestTabManagers2026,
  OneTabAlternatives2026,
  AdhdTabManagement,
  TabOverloadScience,
  OrganizeTabsWithAi,
  BrowserExtensionsForResearchers,
  ChromeExtensionsForStudents,
  ImportPocketExportBlackmount,
  BlackmountVsOnetab,
  BlackmountVsSessionBuddy,
  BlackmountVsWorkona,
];

export function getPostBySlug(slug) {
  return posts.find(p => p.slug === slug) || null;
}

export function getAllPostsSorted() {
  return [...posts].sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
}
